import React, { useState } from 'react';
import './CustomSelect.scss';
import {trackWithGoogleTagManager} from "../../utils/analytics";

const CustomSelect = (props: any) => {
  const [toCall, setToCall] = useState('');
  const [name, setName] = useState('')
  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const track = () => {
    trackWithGoogleTagManager({
      event: 'event_call_center',
      eventLabel: toCall,
      eventAction: name,
      eventCategory: 'call_center'
    })
  }
  return (
    <div
      className={'CustomSelect__container'}
      onClick={() => setIsSelectOpen(!isSelectOpen)}
    >
      {toCall === '' ? (
        <span className={'CustomSelect__toCall'}>{props.placeholder}</span>
      ) : (
        <a
          className={`CustomSelect__toCall ${
            toCall !== '' && 'CustomSelect__green_text'
          }`}
          href={`tel:${toCall}`}
          onClick={(e) => {
            track()
            e.stopPropagation()
          }}
        >
          {toCall}
        </a>
      )}
      <div className={`icon ${'icon-arrow-up'} CustomSelect__iconStyle`} />
      <ul
        className={
          isSelectOpen
            ? 'CustomSelect__select_list CustomSelect__select_list_open'
            : 'CustomSelect__select_list'
        }
      >
        {isSelectOpen &&
          props.optionsList.map((item, index) => (
            <div
              className={'CustomSelect__option'}
              onClick={() => {
                setName(item?.Name)
                setToCall(item?.Value)
              }}
              key={index}
            >
              <p>{item.Name}</p>
            </div>
          ))}
      </ul>
    </div>
  );
};

export default CustomSelect;
